import React, { useId } from 'react';
import { cx } from '../../lib/cx';

/** On/off switch with a visible label and optional description. */
export const Switch = ({ checked, onChange, label, description, disabled = false, className }) => {
  const id = useId();
  return (
    <div className={cx('flex items-start justify-between gap-4 py-1.5', className)}>
      <div className="min-w-0">
        <label htmlFor={id} className="block text-sm text-fg">{label}</label>
        {description && <p id={`${id}-desc`} className="mt-0.5 text-xs text-muted">{description}</p>}
      </div>
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        aria-describedby={description ? `${id}-desc` : undefined}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={cx(
          'relative mt-0.5 inline-flex h-5 w-9 shrink-0 items-center rounded-full border border-transparent transition-colors',
          'disabled:cursor-not-allowed disabled:opacity-50',
          checked ? 'bg-accent-solid' : 'bg-line-strong',
        )}
      >
        <span
          aria-hidden="true"
          className={cx(
            'inline-block h-4 w-4 rounded-full bg-white shadow transition-transform',
            checked ? 'translate-x-4' : 'translate-x-0.5',
          )}
        />
      </button>
    </div>
  );
};
